<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem; margin-bottom: 0!important;">
		<div class="py-2 border-bottom d-flex align-items-center">
			<el-button type="primary" size="mini" icon="el-icon-search">查询</el-button>
		</div>
		<div>
			<el-table :data="khxsList" style="width: 100%" size="mini"	row-key="id" :tree-props="{ children: 'child', hasChildren: 'hasChildren' }"  @current-change="handleCurrentChange">
				<el-table-column width="80" align="center">
					<template slot="header" slot-scope="scope">编号</template>
					<template slot-scope="scope">{{scope.row.id}}</template>
				</el-table-column>
				<el-table-column>
					<template slot="header" slot-scope="scope">提交内容</template>
					<template slot-scope="scope">{{scope.row.tjnr}}</template>
				</el-table-column>
				<el-table-column>
					<template slot="header" slot-scope="scope">客户名称</template>
					<template slot-scope="scope"><el-button type="success" size="mini" plain>{{scope.row.khid.mc}}</el-button></template>
				</el-table-column>
				<el-table-column>
					<template slot="header" slot-scope="scope">提交人</template>
					<template slot-scope="scope"><el-button type="success" size="mini" plain>{{scope.row.cjr.name}}</el-button></template>
				</el-table-column>
				<el-table-column>
					<template slot="header" slot-scope="scope">创建时间</template>
					<template slot-scope="scope">{{scope.row.create_time}}</template>
				</el-table-column>
				
				<el-table-column align="center" fixed="right" width="100">
					<template slot="header" slot-scope="scope">操作</template>
					<template slot-scope="scope">
						<el-button type="primary" size="mini" @click="openModel('khxs',scope.row)">查看</el-button>
					</template>
				</el-table-column>
				
			</el-table>
		</div>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 250px;right: 0;z-index: 100;">
			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper" 	:total="page.total" @size-change="handleSizeChange"
					@current-change="handleCurrentChange"></el-pagination>
			</div>
		</el-footer>
		<el-dialog title="类别详情" :visible.sync="createModel" top="10vh">
			<!-- 表单内容 -->
			<div style="width: 100%;margin-top: 20px;" class="d-flex">
				<div style="width: 33%;">
					<el-form v-if="preUrl ==='khxs' " ref="form" :model="form.khxs" label-width="80px">
						<el-form-item label="信息编号">
							<el-input v-model="form.khxs.id" size="mini" style="width: 95%;" :disabled="true"></el-input>
						</el-form-item>
						<el-form-item label="名称">
							<el-input v-model="form.khxs.cjr" size="mini" style="width: 95%;" :disabled="true"></el-input>
						</el-form-item>
					</el-form>
				</div>
				<div style="width: 33%;">
					<el-form v-if="preUrl ==='khxs' " ref="form" :model="form.khxs" label-width="80px">
						<el-form-item label="提交人">
							<el-button type="success" size="mini">{{form.khxs.cjr}}</el-button>
						</el-form-item>
						<el-form-item label="提交内容">
							<el-input v-model="form.khxs.tjnr" size="mini" style="width: 95%;" :disabled="true"></el-input>
						</el-form-item>
					</el-form>
				</div>
				<div style="width: 33%;">
					<el-form v-if="preUrl ==='khxs' " ref="form" :model="form.khxs" label-width="80px">
						<el-form-item label="创建时间">
							<el-input v-model="form.khxs.create_time" size="mini" style="width: 95%;" :disabled="true"></el-input>
						</el-form-item>
						<el-form-item label="客户名称">
							<el-button type="success" size="mini">{{form.khxs.khid}}</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	mixins: [common], // 引入mixins里的common.js
	inject: ['layout'], // 依赖注入
	data() {
		return {
			form: {
				khxs: {
				},
			},
			createModel: false,
			dialogType: "khxs",
			preUrl: "khxs", //api
			khxsList:[]
		};
		
	},
	computed: {
		...mapState({
			user: state => state.user.user
		})
	},
	methods: {
		getListUrl() {
			return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}`
		},
		// 处理列表结果
		getListResult(e) {
			this.khxsList = e.list
		},
		openModel(type, item = false) {
			// 初始化表单
			switch (type) {
				// 初始化添加管理员
				case 'khxs':
					this.form.khxs = {
						tjnr: item.tjnr,
						cjr: item.cjr.name,
						khid: item.khid.mc,
						create_time: item.create_time,
					}
				break;
			}
			this.createModel = true;
		},
		handleCurrentChange(val) {
			this.currentRow = val;
		}
	}
};
</script>

<style></style>
